// useDebouncedValue — returns a debounced echo of the input value.
//
// The returned value updates `delayMs` after `value` last changed; if `value`
// changes again before the timer fires, the timer is reset. Used by the
// US5 search field so we don't re-rank the autocomplete list on every
// keystroke.

import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounced(value);
    }, delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
